import { render, staticRenderFns } from "./WorkOrderCard.vue?vue&type=template&id=0a52bcc9&"
import script from "./WorkOrderCard.vue?vue&type=script&lang=js&"
export * from "./WorkOrderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports